export const register = {
  // Page header
  label: 'Join EachTeach',
  heading: 'コミュニティ登録',
  intro: 'EachTeachのコミュニティに参加して、教育の質を共に高め合いましょう。',

  // Success state
  successTitle: '登録が完了しました！',
  successBody1: 'EachTeachコミュニティへのご登録ありがとうございます。',
  successBody2: 'ご入力いただいたメールアドレス宛に詳細をお送りします。',

  // Form labels
  form: {
    name: '氏名',
    namePlaceholder: '山田 太郎',
    birthdate: '生年月日',
    email: 'メールアドレス',
    emailPlaceholder: 'example@email.com',
    nationality: '国籍',
    nationalityPlaceholder: '日本',
    organization: '団体名・所属（任意）',
    organizationPlaceholder: '例: ◯◯語学スクール（個人の場合は空欄可）',
    languages: '扱える言語',
    languagesOtherPlaceholder: 'その他の言語があれば入力',
    selected: '選択中',
    category: '区分',
    categorySelect: '選択してください',
    consent:
      '団体名・所属を EachTeach の紹介ページに掲載することに同意します（任意）。',
    consentNote:
      'ご同意いただいた場合でも、掲載は内容確認のうえ行います。未同意でもご登録いただけます。',
    requiredMark: '*',
    submit: '登録する',
    submitting: '送信中...',
  },

  // Category options
  categories: {
    tutor: '個人家庭教師',
    aspiring: '個人家庭教師になりたい人',
    sla: 'SLA分野専門家',
  },

  // Language options
  languages: {
    japanese: '日本語',
    english: '英語',
    chineseMandarin: '中国語（普通話）',
    chineseCantonese: '中国語（広東語）',
    korean: '韓国語',
    spanish: 'スペイン語',
    french: 'フランス語',
    german: 'ドイツ語',
    portuguese: 'ポルトガル語',
    italian: 'イタリア語',
    russian: 'ロシア語',
    arabic: 'アラビア語',
    hindi: 'ヒンディー語',
    turkish: 'トルコ語',
    other: 'その他',
  },

  // Error / validation messages
  errors: {
    saveFailed: '登録の保存に失敗しました。時間をおいて再度お試しください。',
    submitFailed: '送信中にエラーが発生しました。もう一度お試しください。',
  },
};
